<template>
  <ol class="ranking-list">
    <li class="ranking-list__item head-item">
      <div class="rank flex-all-center">
        {{ Ranking.overall[lang] }}
      </div>
      <div class="runner-info flex-all-center">
        {{ Ranking.runner[lang] }}
      </div>
      <div class="time flex-all-center">
        {{ Ranking.time[lang] }}
      </div>
      <template v-for="(ranking_item, index) in dataEventSummary.ranking_items">
        <div
          class="head flex-all-center"
          :key="index"
          v-if="ranking_item == '性別'"
        >
          {{ Ranking.sex[lang] }}
        </div>
        <div
          class="head flex-all-center"
          :key="index"
          v-if="ranking_item == '年代'"
        >
          {{ Ranking.age[lang] }}
        </div>
        <div
          class="head flex-all-center"
          :key="index"
          v-if="ranking_item == '居住地'"
        >
          {{ isCompany ? "都道府県" : Ranking.location[lang] }}
        </div>
        <div
          class="head flex-all-center"
          :key="index"
          v-if="ranking_item == '部署'"
        >
          {{ Ranking.department[lang] }}
        </div>
        <div
          class="head flex-all-center"
          :key="index"
          v-if="ranking_item == '所属'"
        >
          {{ Ranking.affiliation[lang] }}
        </div>
        <div
          class="head flex-all-center"
          :key="index"
          v-if="ranking_item == '支店'"
        >
          {{ Ranking.branch[lang] }}
        </div>
      </template>
      <div
        class="complete flex-all-center"
        v-if="dataEventRanking.text.accumulation_flag && eventStatus === '0'"
      >
        {{ Ranking.runLog[lang] }}
      </div>
      <div class="complete flex-all-center" v-else>
        {{ Ranking.certificate[lang] }}
      </div>
    </li>
    <li
      v-for="(content, index) in filterRunner(dataRanking.contents)"
      :key="index"
      class="ranking-list__item detail-item"
    >
      <!-- ランキング --- : 割り込みランキング -->
      <div v-if="content.total_ranking === '99999999'" class="rank">
        <span>---</span>
      </div>
      <!-- 累積イベント && 暫定(status === '0') && DNFの人 -->
      <div
        v-else-if="
          dataEventRanking.text.accumulation_flag &&
          eventStatus === '0' &&
          content.ranking === 'DNF'
        "
        class="rank"
      >
        <img src="../../../assets/images/ranking/runner.svg" alt="" />
      </div>
      <div v-else-if="content.total_ranking === '1'" class="rank">
        <img src="../../../assets/images/ranking/1st-place.svg" alt="" />
      </div>
      <div v-else-if="content.total_ranking === '2'" class="rank">
        <img src="../../../assets/images/ranking/2nd-place.svg" alt="" />
      </div>
      <div v-else-if="content.total_ranking === '3'" class="rank">
        <img src="../../../assets/images/ranking/3rd-place.svg" alt="" />
      </div>
      <div v-else class="rank">
        {{ content.total_ranking }}
      </div>
      <div class="runner-info">
        <div class="runner">{{ content.runner_name }}</div>
        <div class="entry-id">{{ content.entry_id }}</div>
      </div>
      <div class="time">{{ content.result_time }}</div>
      <template v-for="(ranking_item, index) of dataEventSummary.ranking_items">
        <div class="gender" v-if="ranking_item === '性別'" :key="index">{{
          content.gender[lang]
        }}</div>
        <div class="age" v-if="ranking_item === '年代'" :key="index">{{
          content.age
        }}</div>
        <!-- 特別対応 2021/03/01 既存APIと束ねAPIでレスポンスに差分があるため -->
        <div
          class="area"
          v-if="isForeignCountry && ranking_item === '居住地'"
          :key="index"
          >{{ content.country_name }}</div
        >
        <div
          class="area"
          v-else-if="!isForeignCountry && ranking_item === '居住地'"
          :key="index"
          >{{ content.area_name[lang] }}</div
        >
        <div class="department" v-if="ranking_item === '部署'" :key="index">{{
          content.department
        }}</div>
        <div class="branch" v-if="ranking_item === '支店'" :key="index">{{
          content.branch
        }}</div>
        <div class="affiliation" v-if="ranking_item === '所属'" :key="index">{{
          content.affiliation
        }}</div>
      </template>
      <div class="complete">
        <!-- ランキング99999999位 : 割り込みランキング -->
        <a
          href="https://tmf-virtualrun.jp/pdf/certificate/2020/RaO/1200239.pdf"
          class="certificate confirm"
          v-if="content.total_ranking === '99999999'"
        >
          {{ Ranking.certificate[lang] }}
        </a>
        <!-- 累積イベント && DNFの人 : 距離を表示 -->
        <template
          v-else-if="
            dataEventRanking.text.accumulation_flag && content.ranking === 'DNF'
          "
        >
          {{ content.distance }}
        </template>
        <!-- 確定時 && 完走者 : 完走証へのリンク -->
        <router-link
          :to="{
            path: `/${langPath}${
              $route.path.includes('company') ? 'company/' : ''
            }ranking/certificate`,
            query: {
              event: nassEventId,
              runner: content.id,
            },
          }"
          class="certificate confirm"
          v-else-if="
            eventStatus === '100' &&
            content.ranking !== 'DNS' &&
            content.ranking !== 'DNF'
          "
        >
          {{ Ranking.certificate[lang] }}
        </router-link>
      </div>
    </li>
  </ol>
</template>

<script>
export default {
  methods: {
    filterRunner: function (rankingContents) {
      return rankingContents.filter(
        (runner) => this.eventStatus === "100" || runner.ranking !== "DNS"
      );
    },
  },
  props: {
    lang: String,
    langPath: String,
    Ranking: Object,
    dataEventRanking: Object,
    dataEventSummary: Object,
    dataRanking: Object,
    eventStatus: String,
    isForeignCountry: Boolean,
    isCompany: Boolean,
    nassEventId: String,
  },
  created() {
    // VMGCイベント向け暫定
    if (this.nassEventId === "0000000057") {
      this.dataEventRanking.text.accumulation_flag = true;
    }
  },
  name: "RankingList",
};
</script>

<style scoped>
.ranking-list {
  margin: 40px 0 0 0;

  .rank,
  .head,
  .gender,
  .age,
  .area,
  .time,
  .department,
  .branch,
  .affiliation,
  .complete,
  .runner-info {
    margin: 0 18px 0 0;
  }

  .rank,
  .head,
  .gender,
  .age,
  .area,
  .department,
  .branch,
  .affiliation {
    width: 100px;
  }

  .time,
  .complete {
    width: 120px;
  }

  .runner-info {
    flex: 1;
  }

  .ranking-list__item {
    margin: 0 -18px 0 0;
    display: flex;
    text-align: center;
  }

  .head-item {
    font-size: 18px;
    font-weight: bold;

    .rank,
    .head,
    .gender,
    .age,
    .area,
    .time,
    .department,
    .branch,
    .affiliation,
    .complete,
    .runner-info {
      padding: 0 0 12px 0;
      border-bottom: solid 3px #000;
    }
  }

  .detail-item {
    padding: 25px 0;
    min-height: 120px;
    align-items: center;
    border-bottom: solid 1px #999;

    .rank {
      font-size: 30px;
      font-weight: bold;
    }

    .runner-info {
      padding: 0 0 0 10px;
      text-align: left;

      .runner {
        font-size: 24px;
        font-weight: bold;
      }

      .entry-id {
        margin: 4px 0 0 0;
        font-size: 14px;
      }
    }

    .time {
      font-size: 24px;
      font-weight: bold;
    }

    .head,
    .gender,
    .age,
    .area,
    .department,
    .branch,
    .affiliation {
      font-size: 20px;
    }

    .complete {
      font-size: 20px;
      font-weight: bold;
    }

    .certificate {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 70px;
      border: solid 1px #000;
      background-color: #fff;
      font-size: 14px;
      font-weight: normal;

      &::before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 16px;
        margin: 0 0 4px 0;
        background: url("../../../assets/images/certificate/certificate.svg")
          no-repeat center / 12px 16px;
      }
    }

    .confirm {
      &:hover {
        color: #fff;
        background-color: #000;

        &::before {
          background: url("../../../assets/images/certificate/certificate-hover.svg")
            no-repeat center / 12px 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ranking/RankingList.vue